var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticStyle:{"position":"absolute","top":"0","bottom":"0"},attrs:{"src":_vm.requireImg(),"height":"100%","width":"100%"}},[_c('v-overlay',{attrs:{"color":_vm.color,"z-index":_vm.zIndex,"absolute":"","opacity":_vm.opacity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }